import script from "./Menus.vue?vue&type=script&setup=true&lang=ts"
export * from "./Menus.vue?vue&type=script&setup=true&lang=ts"

import "./Menus.vue?vue&type=style&index=0&id=668fdddd&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-668fdddd"]])

export default __exports__